import { createQueryKeyStore } from '@lukemorales/query-key-factory';

import APIinstance from './config';
import { fetchFinalFileUrl } from './file-service';

import { PartnerDto } from '@/generated-types';

export const partnersQueries = createQueryKeyStore({
	partner: {
		me: ['partner/me'],
		metaLogo: (publicLogoUrl: string) => ({
			queryKey: ['logoFinalUrl', publicLogoUrl],
			queryFn: () => fetchFinalFileUrl(publicLogoUrl),
			staleTime: Infinity,
			gcTime: Infinity,
		}),
		metaFavicon: (publicFaviconUrl: string) => ({
			queryKey: ['faviconFinalUrl', publicFaviconUrl],
			queryFn: () => fetchFinalFileUrl(publicFaviconUrl),
			staleTime: Infinity,
			gcTime: Infinity,
		}),
	},
});

export const getPartnerConfig = async (partnerSlug: string): Promise<Required<PartnerDto>> => {
	const { data } = await APIinstance.get<Required<PartnerDto>>(`partners/${partnerSlug}`);
	return data;
};
